import GreetingOccasionCategoryService from "../../../../services/GreetingOccasionCategoryService";
import GreetingOccasionImageService from "../../../../services/GreetingOccasionImageService";
import { GreetingOccasionCategoryViewModel } from "../../../../viewModels";
import GreetingOccasionImage from "../../../../models/GreetingOccasionImage";
import { PaginationResult } from "../../../../lib/definitions";

const apiCategory = new GreetingOccasionCategoryService();
const apiImage = new GreetingOccasionImageService();
export async function fetchCategories():Promise<GreetingOccasionCategoryViewModel[]>{
    return await apiCategory.getGreetingOccasionCategories();
}

export async function fetchCategoryById(id: number):Promise<GreetingOccasionCategoryViewModel>{
    return await apiCategory.getGreetingOccasionCategoryById(id);
}

export async function fetchGreetingOccasionImagesByCategoryId(categoryId: number,page: number, pageSize: number):Promise<PaginationResult<GreetingOccasionImage>>{
    return await apiImage.getGreetingOccasionImagesByCategoryId(categoryId,page, pageSize);
}

export type State = {
    message: string | null;
    success: boolean;
    errors: {
        isComedy?: string[];
        isActive?: string[];
    };
}
export async function setIsComedy(id: number, prevState: State, formData: FormData):Promise<State>{
    try{
        const comedy=!(formData.get("isComedy") === "true");
        const result =await apiImage.setIsComedy(id, comedy);
        console.log(result);
        if(result.status === 204){
            return {
                message: comedy?"Image is set to be comedy":"Image is set to be not comedy",
                success: true,
                errors: {},
            };
        }
        else{
            return {
                message: "Failed to update IsComedy.",
                success: false,
                errors: {},
            };
        }
    }
    catch(error){
        console.log(error);
        return {
            message: "Failed to update IsComedy.",
            success: false,
            errors: {},
        };
    }
}

export async function setIsActive(id: number, prevState: State, formData: FormData):Promise<State>{
    try{
        const active=!(formData.get("isActive") === "true");
        const result =await apiImage.setIsActive(id, active);
        console.log(result);
        if(result.status === 204){
            return {
                message: active?"Image is set to be visible":"Image is set to be hidden",
                success: true,
                errors: {},
            };
        }
        else{
            return {
                message: "Failed to update IsActive.",
                success: false,
                errors: {},
            };
        }
    }
    catch(error){
        console.log(error);
        return {
            message: "Failed to update IsActive.",
            success: false,
            errors: {},
        };
    }
}

export async function deleteGreetingOccasionImage(id: number, prevState: State):Promise<State>{
    try{
        const result =await apiImage.deleteGreetingOccasionImage(id);
        console.log(result);
        if(result.status === 204){
            return {
                message: "Greeting occasion image deleted successfully.",
                success: true,
                errors: {},
            };
        }
        else{
            return {
                message: "Failed to delete greeting occasion image.",
                success: false,
                errors: {},
            };
        }
    }
    catch(error){
        console.log(error);
        return {
            message: "Failed to delete greeting occasion image.",
            success: false,
            errors: {},
        };
    }
}

export async function uploadImage(categoryId: number, image: File){
    try{
        const formData = new FormData();
        formData.append("file", image);
        const result = await apiImage.uploadGreetingOccasionImage(categoryId, formData);
        if(result.status === 201){
            return {
                message: "Image uploaded successfully.",
                success: true,
                errors: {},
            };
        }
    }
    catch(error){
        console.log(error);
        return {
            message: "Failed to upload image.",
            success: false,
            errors: {},
        };
    }
}